import React, { useState , useEffect } from 'react';
import emailjs from 'emailjs-com';
import Navbar from './Navbar';
import Footer from './Footer';
import '../styles/Contact.css';

const Contact = () => {

  useEffect(() => {
      document.title = "Contact Us - Legal Trails";  // Set Page Title
    }, []);


  const [formData, setFormData] = useState({
    from_name: '',
    email: '',
    phone: '',
    message: '',
  });
  const [validationErrors, setValidationErrors] = useState({});
  const [status, setStatus] = useState({
    submitted: false,
    success: false,
    message: '',
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const validateForm = () => {
    const errors = {};

    if (!formData.phone || !/^\d{10,}$/.test(formData.phone)) {
      errors.phone = 'Invalid phone number. Please enter a valid 10-digit phone number.';
    }

    if (!formData.from_name.trim()) errors.from_name = 'Name is required.';
    if (!formData.email.match(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/))
      errors.email = 'Invalid email address.';
    if (!formData.message.trim()) errors.message = 'Message cannot be empty.';

    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    setValidationErrors({});
    const serviceID = 'service_ysslttr';
    const templateID = 'template_g0loyoo';
    const userID = 'rUPuUQLWvbTmZHBHb';

    emailjs
      .send(serviceID, templateID, formData, userID)
      .then((response) => {
        console.log('SUCCESS!', response.status, response.text);
        setStatus({
          submitted: true,
          success: true,
          message: 'Your form has been submitted successfully😊',
        });
      })
      .catch((err) => {
        console.error('FAILED...', err);
        setStatus({
          submitted: true,
          success: false,
          message: 'There was an error sending your message. Please try again later.',
        });
      });

    setFormData({
      from_name: '',
      email: '',
      phone: '',
      message: '',
    });
  };

  return (
    <>
      <Navbar />
      <div className="contact-container">
        <header className="contact-header text-center py-5">
        <div className="image-container">
  <img
    src="Contact-Us.jpg"
    alt="Our Team"
  />
</div>
          
        </header>
        <section className="contact-form py-5">
          <div className="container">
          <div className="container">
            {/* <h1>Contact Us</h1> */}
            <p>We'd love to hear from you! Please fill out the form below and we will get in touch with you as soon as possible.</p>
          </div>
            {!status.submitted ? (
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="from_name">Name</label>
                  <input
                    type="text"
                    id="from_name"
                    name="from_name"
                    value={formData.from_name}
                    onChange={handleChange}
                    required
                  />
                  {validationErrors.from_name && (
                    <p className="error">{validationErrors.from_name}</p>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                  {validationErrors.email && (
                    <p className="error">{validationErrors.email}</p>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="phone">Phone</label>
                  <input
                    type="text"
                    id="phone"
                    name="phone"
                    placeholder="Enter your Mobile Contact number"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                  {validationErrors.phone && (
                    <p className="error">{validationErrors.phone}</p>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="message">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                  {validationErrors.message && (
                    <p className="error">{validationErrors.message}</p>
                  )}
                </div>
                <button type="submit" className="btn btn-primary">Submit</button>
              </form>
            ) : (
              <div className="success-message text-center">
                {status.success ? (
                  <div className="success-container">
                    <div className="success-icon">
                      <span style={{ color: 'blue', fontSize: '3rem' }}>✔️</span>
                    </div>
                    <p>{status.message}</p>
                  </div>
                ) : (
                  <p className="error">{status.message}</p>
                )}
              </div>
            )}
          </div>
        </section>
      
      {/* FAQ Section */}
<section className="faq-section py-5">
<div className="faq-container">
  <h2>Frequently Asked Questions (FAQs)</h2>
  <div className="faq-item">
    <h5>How can I contact you?</h5>
    <p>You can contact us by filling out the form above or directly via email at contactlegaltrails@gmail.com</p>
  </div>
  <div className="faq-item">
    <h5>What services do you offer?</h5>
    <p>We offer a wide range of legal services including Legal Consultation, Litigation, Building & Political Legal Compliances, Trademark Registration & Litigation, POSH  Compliance & Agreements Drafting</p>
  </div>
  <div className="faq-item">
    <h5>How soon will I get a response?</h5>
    <p>We aim to respond to all queries within 24-48 hours during business days.</p>
  </div>
</div>
</section>
</div>
      <Footer />
    </>
  );
};

export default Contact;
